// src/pages/admin/AdminApp.jsx

import React from "react";
import AdminNewsPage from "./AdminNewsPage";
import NewsFormPage from "./NewsFormPage";
import NewsDetailPage from "./NewsDetailPage";
import { useNavigate } from "react-router-dom";

// 追加： Minpaku 用コンポーネント
import MinpakuList   from "./MinpakuList";
import MinpakuDetail from "./MinpakuDetail";
import MinpakuForm   from "./MinpakuForm";

// 追加： 不動産（売買物件）用コンポーネント
import RealEstateList   from "./RealEstateList";
import RealEstateDetail from "./RealEstateDetail";
import RealEstateForm   from "./RealEstateForm";

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// 認証チェック（仮）
const isAuthenticated = true;

const ProtectedRoute = ({ children }) =>
  isAuthenticated ? children : <Navigate to="/admin/login" />;

export default function AdminApp() {
  const navigate = useNavigate();

  // ログアウト処理
  const handleLogout = () => {
    localStorage.removeItem("admin_jwt");
    localStorage.removeItem("authenticated"); // 認証系全部消す
    navigate("/");
    window.location.reload();
  };
  
  return (
    <div className="adm-page">
      {/* ヘッダー（タイトル＋ログアウト） */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <h1 className="text-lg font-bold text-gray-800">
            アプロ山梨 管理画面
          </h1>
          <button
            onClick={handleLogout}
            className="text-sm font-medium bg-red-600 text-white rounded-md px-4 py-1.5 hover:bg-red-700 transition"
          >
            ログアウト
          </button>
        </div>
        {/* ナビゲーション */}
        <nav className="max-w-5xl mx-auto px-4 pb-3 flex flex-wrap gap-2">
          <a href="/admin/news" className="adm-navlink">お知らせ</a>
          <a href="/admin/minpaku" className="adm-navlink">民泊物件</a>
          <a href="/admin/realestate" className="adm-navlink">売買物件</a>
          <a href="/admin/images" className="adm-navlink">画像管理</a>
        </nav>
      </header>

      <main className="adm-wrap">
      <Routes>
        <Route path="/" element={
          <div className="adm-card">
            <h2 className="adm-title mb-2">管理ダッシュボード</h2>
            <p className="text-gray-600 text-sm">上のメニューから編集する項目を選んでください。</p>
          </div>
        } />

        {/* お知らせ */}
        <Route path="/news"      element={<ProtectedRoute><AdminNewsPage /></ProtectedRoute>} />
        <Route path="/news/new"  element={<ProtectedRoute><NewsFormPage /></ProtectedRoute>} />
        <Route path="/news/:id"  element={<ProtectedRoute><NewsDetailPage /></ProtectedRoute>} />
        <Route path="/news/:id/edit" element={<ProtectedRoute><NewsFormPage /></ProtectedRoute>} />

        {/* 民泊 */}
        <Route path="/minpaku"        element={<ProtectedRoute><MinpakuList   /></ProtectedRoute>} />
        <Route path="/minpaku/new"    element={<ProtectedRoute><MinpakuForm   /></ProtectedRoute>} />
        <Route path="/minpaku/:id"    element={<ProtectedRoute><MinpakuDetail /></ProtectedRoute>} />
        <Route path="/minpaku/:id/edit" element={<ProtectedRoute><MinpakuForm   /></ProtectedRoute>} />

        {/* 不動産（売買物件） */}
        <Route path="/realestate"          element={<ProtectedRoute><RealEstateList   /></ProtectedRoute>} />
        <Route path="/realestate/new"      element={<ProtectedRoute><RealEstateForm   /></ProtectedRoute>} />
        <Route path="/realestate/:id"      element={<ProtectedRoute><RealEstateDetail /></ProtectedRoute>} />
        <Route path="/realestate/:id/edit" element={<ProtectedRoute><RealEstateForm   /></ProtectedRoute>} />

        {/* その他 */}
        <Route path="/images"     element={<ProtectedRoute>
          <div className="adm-card">
            <h2 className="adm-title mb-2">画像管理</h2>
            <p className="text-gray-600 text-sm">この機能は準備中です。</p>
          </div>
        </ProtectedRoute>} />

      </Routes>
      </main>
    </div>
  );
}
